import React from 'react';

import { RatingContainer, RatingItem } from './styles';

interface RatingProps {
  options: number[];
  defaultValue?: number;
  onChange?: (value: number | null) => void;
}

const Rating: React.FC<RatingProps> = ({ options, defaultValue, onChange }) => {
  const [valueFocused, setValueFocused] = React.useState(-1);
  const [value, setValue] = React.useState(defaultValue || -1);

  const handleItemClick = React.useCallback(
    (option: number) => {
      setValue(prev => {
        let newValue = -1;
        if (prev !== option) {
          newValue = option;
        }

        if (onChange) {
          onChange(newValue === -1 ? null : newValue);
        }
        return newValue;
      });
    },
    [onChange],
  );

  const RatingItems = React.useMemo(() => {
    return (
      options.length &&
      options.map(opt => {
        return (
          <RatingItem
            key={opt.toString()}
            onMouseEnter={() => setValueFocused(opt)}
            onClick={() => handleItemClick(opt)}
            focused={opt <= valueFocused}
            actived={opt <= value}
          >
            {opt}
          </RatingItem>
        );
      })
    );
  }, [handleItemClick, options, value, valueFocused]);

  return (
    <RatingContainer onMouseLeave={() => setValueFocused(-1)}>
      {RatingItems}
    </RatingContainer>
  );
};

export default Rating;
